import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const steps = [
  {
    number: '1️⃣',
    title: 'Answer Simple Questions',
    description: "Our smart wizard focuses on the details California leases typically need—no unnecessary jargon.",
  },
  {
    number: '2️⃣',
    title: 'Apply CA Laws',
    description: 'We surface common California disclosures (lead paint, wildfire risk, rent caps) for you to include as needed.',
  },
  {
    number: '3️⃣',
    title: 'E-Sign & Done',
    description: 'Send to tenants for digital signature. Get your lease finalized faster.',
  },
];

const HowItWorksSection: React.FC = () => {
  return (
    <SectionBackground className="features" style={{ padding: '80px 16px' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 60, fontWeight: 700 }}>
          How TenantTerms Works
        </h2>
        <div className="features-grid">
          {steps.map((step, idx) => (
            <div className="feature-card" key={idx} style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: '#EFF6FF',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '2rem',
              }}>
                {step.number}
              </div>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '15px', fontWeight: 600 }}>
                {step.title}
              </h3>
              <p style={{ color: 'var(--text-light)' }}>
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default HowItWorksSection; 
